<template>
  <div>
    <form id="form-contact">
      <div class="no-padding no-margin text-right validation-message">
        *Campos obrigatórios
      </div>
      <b-form-group
        class="input-group-name"
      >
        <label
          >Nome completo
          <span v-if="!form.name" class="text-danger">*</span>
        </label>
        <b-form-input
          id="input-name"
          v-model="form.name"
          type="text"
          :isInvalid="!!errors.name"
          placeholder=""
          required
          trim
        ></b-form-input>
         <b-form-invalid-feedback
          v-if="errors.name"
          class="d-block"
          v-html="errors.name"
          />
      </b-form-group>

      <b-form-group class="form-group">
        <label
          >E-mail de contato
          <span v-if="!form.email" class="text-danger">*</span>
        </label>
        <b-form-input
          id="input-email"
          v-model="form.email"
          :isInvalid="!!errors.email"
          @focus="focusEmail()"
          type="email"
          placeholder=""
          required
          trim
        ></b-form-input>
         <b-form-invalid-feedback
          v-if="errors.email"
          class="d-block"
          v-html="errors.email"
          />
      </b-form-group>

      <div class="form-group">
        <label for="formCampaign"
          >Sobre qual campanha você quer falar?
          <span v-if="!form.campaign" class="text-danger">*</span>
        </label>
        <select v-model="form.campaign" class="form-control" id="formCampaign">
          <option v-for="(campaign, index ) in campaigns" :value="campaign.value"
          :key="index"
          :disabled="campaign.disable"
          required
          >
            {{ campaign.text }}
          </option>
        </select>
        <b-form-invalid-feedback
          v-if="errors.campaign"
          class="d-block"
          v-html="errors.campaign"
          />
      </div>

      <b-form-group
        id="select-group-subject"
      >
        <label for="formSubject"
          >Assunto
          <span v-if="!form.contactReason" class="text-danger">*</span>
        </label>
         <select v-model="form.contactReason" class="form-control" id="formSubject"
            @change="getDetailFromSubject">
            <option v-for="subject in subjects" :value="subject.text"
            :key="subject.text"
            :disabled="subject.disable"
            required
            >
              {{ subject.text }}
            </option>
          </select>
          <b-form-invalid-feedback
          v-if="errors.contactReason"
          class="d-block"
          v-html="errors.contactReason"
          />
      </b-form-group>

      <b-form-group
        v-if="form.contactReason"
      >
        <label for="formDetail"
          >Detalhe do assunto
          <span v-if="!form['subject-detail']" class="text-danger">*</span>
        </label>
         <select v-model="form['subject-detail']" class="form-control" id="formDetail">
            <option v-for="detail in details" :value="detail.text"
            :key="detail.text"
            :disabled="detail.disable"
            required
            >
              {{ detail.text }}
            </option>
          </select>
      </b-form-group>

      <b-form-group
      >
        <label
          >Mensagem
          <span v-if="!form.message" class="text-danger">*</span>
        </label>

        <b-form-textarea
          placeholder=""
          v-model="form.message"
          required
        ></b-form-textarea>
        <b-form-invalid-feedback
          v-if="errors.message"
          class="d-block"
          v-html="errors.message"
          />
      </b-form-group>

      <b-form-group class="input-group-file">
        <label
          >Anexar
          <span class="attachment-label"
            >(Imagens, arquivos ou documentos que ilustrem seu contato)</span
          >
        </label>
        <b-form-file
          class="form-control"
          accept="application/pdf, image/*"
          v-model="form.attachment"
          placeholder="Adicione o arquivo ou arraste até aqui"
        >
        </b-form-file>
        <b-form-invalid-feedback
          v-if="errors.attachment"
          class="d-block"
          v-html="errors.attachment"
          />
      </b-form-group>

      <b-form-group class="input-group-7">
        <Recaptcha v-on:recaptcha-event="recaptchaVerified" />
      </b-form-group>

      <b-button
        class="btn-submit"
        :disabled="!verified"
        variant="primary"
        @click="validateForm()"
        >Enviar</b-button
      >
    </form>

    <b-modal
      id="modal-success"
      ref="modalSuccess"
      title="E-mail enviado com sucesso"
    >
      <p class="my-4">
        Muito obrigado. Recebemos seu e-mail e em breve um de nossos atendentes
        entrará em contato com você.
      </p>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="btn-close-modal float-right"
            @click="closeModalSuccess()"
          >
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Recaptcha from '@/components/recaptcha/Recaptcha';
import ContactApi from '@/services/contact';
import store from '@/store';


export default {
  name: 'ContactForm',
  components: {
    Recaptcha,
  },
  computed: {
    ...mapGetters([
      'affiliateInfo',
    ]),
  },
  data() {
    return {
      // eslint-disable-next-line
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      verified: false,
      form: {
        name: undefined,
        email: undefined,
        campaign: undefined,
        contactReason: undefined,
        'subject-detail': undefined,
        message: undefined,
        attachment: undefined,
        namLogin: undefined,
      },
      errors: {
        name: null,
        email: null,
        campaign: null,
        contactReason: null,
        subject: null,
        message: null,
        attachment: null,
      },
      campaigns: [
        {
          text: 'Selecione uma campanha',
          value: null,
          disable: true,
          selected: true,
        },
        {
          text: 'PagBank',
          value: 'pagseguro',
          disable: false,
          selected: '',
        },
        {
          text: 'UOL/Outros produtos',
          value: 'uol',
          disable: false,
          selected: '',
        },
      ],
      subjects: [
        { text: 'Selecione um assunto', disable: true },
        { text: 'Campanhas', disable: false },
        { text: 'Aprovação', disable: false },
        { text: 'Cadastro', disable: false },
        { text: 'Pagamentos', disable: false },
        { text: 'Relatórios', disable: false },
      ],
      details: [],
      campaign: {
        details: [
          {
            text: 'Selecione um detalhe de assunto', disable: true,
          },
          {
            text: 'Não vejo a aba Campanhas',
            disable: false,
          },
          {
            text: 'Problemas para gerar links, banners ou e-mails',
            disable: false,
          },
          {
            text: 'Gerar links para redes socais',
            disable: false,
          },
          {
            text: 'O anúncio inserido não aparece',
            disable: false,
          },
          {
            text: 'Negociações especiais',
            disable: false,
          },
        ],
      },
      approval: {
        details: [
          {
            text: 'Selecione um detalhe de assunto', disable: true,
          },
          {
            text: 'Solicitar reavaliação de página',
            disable: false,
          },
          {
            text: 'Solicitar reavaliação de campanha',
            disable: false,
          },
        ],
      },
      register: {
        details: [
          { text: 'Selecione um detalhe de assunto', disable: true },
          { text: 'Esqueci meu login ou senha', disable: false },
          { text: 'Alteração de dados cadastrais', disable: false },
          { text: 'Cancelamento de conta', disable: false },
          { text: 'Reativação de cadastro', disable: false },
          { text: 'Não consigo me cadastrar', disable: false },
        ],
      },
      payment: {
        details: [
          { text: 'Selecione um detalhe de assunto', disable: true },
          { text: 'Não recebi meu pagamento', disable: false },
          { text: 'Alterar dados bancários', disable: false },
          { text: 'Informe de rendimentos', disable: false },
        ],
      },
      repport: {
        details: [
          { text: 'Selecione um detalhe de assunto', disable: true },
          { text: 'Venda não aparece no relatório', disable: false },
          { text: 'Erros em relatórios', disable: false },
        ],
      },
      show: true,
    };
  },
  methods: {
    validateForm() {
      let valid = true;
      if (this.form.name === undefined) {
        this.errors.name = 'Digite o nome completo.';
        valid = false;
      }

      if (this.form.email === undefined) {
        this.errors.email = 'Digite um email para contato.';
        valid = false;
      }

      if (this.form.campaign === undefined) {
        this.errors.campaign = 'Escolha uma campaign.';
        valid = false;
      }

      if (this.form.contactReason === undefined) {
        this.errors.contactReason = 'Escolha um assunto.';
        valid = false;
      }

      if (this.form.message === undefined) {
        this.errors.message = 'Descreva o que está ocorrendo.';
        valid = false;
      }

      if (this.form.attachment !== undefined) {
        if (this.checkFileSize(this.form.attachment)) {
          this.errors.attachment = 'O arquivo deve ter no maximo 2MB';
          valid = false;
        }
      }

      if (valid === true) {
        this.save();
      }

      return valid;
    },
    checkFileSize(file) {
      const newFile = file;
      const FileSize = newFile.size / 1024 / 1024;
      if (FileSize > 2) {
        return true;
      }
      return false;
    },
    focusEmail() {
      if (this.form.email === undefined) {
        this.form.email = this.affiliateInfo.namLogin;
      }
    },
    recaptchaVerified() {
      this.verified = true;
    },
    async save() {
      store.dispatch('startLoading');
      this.form.namLogin = this.affiliateInfo.namLogin;
      try {
        const response = await ContactApi.send(this.form);
        if (response.status !== 'error') {
          store.dispatch('stopLoading');
          this.showModalSuccess();
        } else {
          console.error('error: ', response);
        }
      } catch (e) {
        console.error('error: ', e);
      }
    },
    onSubmit(event) {
      event.preventDefault();
      this.save();
    },
    onReset(event) {
      event.preventDefault();
      this.form.name = undefined;
      this.form.email = undefined;
      this.form.contactReason = undefined;
      this.form.campaign = undefined;
      this.form['subject-detail'] = undefined;
      this.form.message = undefined;
      this.form.attachment = undefined;
      this.form.namLogin = undefined;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    getDetailFromSubject() {
      switch (this.form.contactReason) {
        case 'Campanhas':
          this.details = this.campaign.details;
          break;
        case 'Aprovação':
          this.details = this.approval.details;
          break;
        case 'Cadastro':
          this.details = this.register.details;
          break;
        case 'Pagamentos':
          this.details = this.payment.details;
          break;
        case 'Relatórios':
          this.details = this.repport.details;
          break;
        default:
          this.details = [];
          break;
      }
      this.form['subject-detail'] = null;
    },
    showModalSuccess() {
      this.$refs.modalSuccess.show();
    },
    closeModalSuccess() {
      this.$refs.modalSuccess.hide();
      window.location.href = 'https://afiliados.uol.com.br/app';
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-message {
  font-size: 13px;
  font-style: italic;
  color: $text-error;
}

.attachment-label {
  font-size: 13px;
}

.btn-submit {
  background-color: $strong-orange;
  border-color: $strong-orange;
  margin-bottom: 5px;
}

.btn-close-modal {
  background-color: $strong-orange;
  border-color: $strong-orange;
}

label {
   font: 14px $font-1;
   color: $text-neutral;
}

/deep/ {
  .custom-file-label {
    text-align: center;
    border: 0;
    height: 100%;
    &::after {
      display: none;
    }
  }
}
</style>
